import React from 'react';
import { Alert, Box } from '@mui/material';
import EnhancedReportingDashboard from '../../components/Reporting/EnhancedReportingDashboard';
import { useSiteContext } from '../../hooks/useSiteContext';

const Reports: React.FC = () => {
  const { currentSite } = useSiteContext();

  if (!currentSite) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">Select a site to view reporting data.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <EnhancedReportingDashboard 
        siteId={currentSite.siteId}
        siteName={currentSite.siteName}
      />
    </Box>
  );
};

export default Reports; 